module.exports = __webpack_public_path__ + "img/logo_4.127877ed.png";